import initGrowthBook from './growthbook';
import trackGrowthBookExperimentDetails from './growthBookTracking';
import resolveGrowthBookClientKey from './growthbookClientKeys';
export { initGrowthBook };

if (typeof window !== 'undefined') {
	if (!window.modUtils) {
		// eslint-disable-next-line no-console
		console.warn('[mod-utils] window.modUtils not found. Load modutils.min.js before growthbook.min.js');
	} else {
		window.modUtils.initGrowthBook = initGrowthBook;
		window.modUtils.trackGrowthBookExperimentDetails = trackGrowthBookExperimentDetails;
		window.modUtils.resolveGrowthBookClientKey = resolveGrowthBookClientKey;
		// How long from page start until growthbook.min.js finished loading and running (ms).
		window.modUtils.timeTakenFromPageLoadToGBScriptReady = Math.round(performance.now());
		// How long the browser took to download growthbook.min.js over the network (ms).
		const gbEntry = performance.getEntriesByType('resource').find((entry) => entry.name.includes('growthbook-'));
		window.modUtils.timeTakenToDownloadGBScript = gbEntry ? Math.round(gbEntry.duration) : null;
	}
}
